import React from "react";
import ActionsPopup from "../ActionsPopup";
import schema from "../ActionsPopup/foreign_worker_group_actions";
import cellGenerator from "./columnUtils";

const foreign_worker_group_columns = (isSubaccount, groupId) => [
  {
    id: "profile-name",
    Header: "Group Name",
    accessor: "ForeignWorkerGroupFormData.new_group_fw_group_name",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "Number of Profiles",
    accessor: "ForeignWorkerGroupFormData.new_group_fw_num_profiles",
    Cell: (props) => cellGenerator(props),
  },
  {
    id: "actions",
    Header: "Actions",
    accessor: (d) => d,
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <ActionsPopup
        actionsPopupSchema={schema(
          "foreign-worker-group",
          isSubaccount,
          groupId
        )}
        id={original.id}
      />
    ),
  },
];

export default foreign_worker_group_columns;
